import { Component, OnInit, HostBinding, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
    standalone: false,
  selector: 'accordion-group',
  templateUrl: './accordion-group.component.html',
  styleUrls: ['./accordion-group.component.scss']

})
export class AccordionGroupComponent implements OnInit {

  @HostBinding('class')
  public readonly hostClass = 'accordion-group';

  @Input() active = false;
  @Input() title: string;
  @Input() templateRef: TemplateRef<any>;
  @Input() titleClass: string;

  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}
